import { useEffect, useState, useMemo } from "react";
import { useProperties } from "./useGetProperties";

export const useAvailableCities = () => {
  const { properties } = useProperties();
  const [allCities, setAllCities] = useState<string[]>([]);

  useEffect(() => {
    if (properties?.length > 0) {
      const uniqueCities = Array.from(
        new Set(properties.map((property) => property.building.city))
      ) as string[];
      setAllCities(uniqueCities);
    }
  }, [properties]);

  return useMemo(() => allCities, [allCities]);
};
